// extracted by css-extract-rspack-plugin
export default {"root":"root-rn3lOK","inline":"inline-FhFnym","grid":"grid-T6tUHV"};